import './proj4';
import Highcharts from 'highcharts';
import HighchartsMap from 'highcharts/modules/map';
import customWorld from './world.json';
require('highcharts/modules/exporting')(Highcharts);

if (typeof window !== 'undefined') {
  HighchartsMap(Highcharts);
  Highcharts.maps['custom/world'] = customWorld;
}

export default Highcharts;
